import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    backgroundImage:
      "url('https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/images/grey-doodles.png')",
    backgroundSize: "cover",
    backgroundPosition: "bottom",
    padding: theme.spacing(5, 0, 10),
  },
  doodle: {
    padding: "40px 40px 0 40px",
    backgroundImage:
      "url('https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/images/green-doodle-homepage-flip.svg')",
    backgroundPosition: "right 2.5% top 50.6%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "40px",
    fontWeight: 700,
    fontSize: "2.95rem",
    ["@media (max-width:576px)"]: { // eslint-disable-line no-useless-computed-key
      backgroundImage: "none",
    },
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
}));

function Hero() {
  const classes = useStyles();
  return (
    <div className={classes.heroContent}>
      <Container maxWidth="sm">
        <Typography
          className={classes.doodle}
          component="h1"
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          Vidyard CTA Catalog
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          color="textSecondary"
          paragraph
        >
          Ready to level up your video content with custom CTAs? Vidyard
          Professional Services can help! Choose a template below to get
          started. We'll help you to customize the CTA with your preferred
          colors, fonts, logo and messaging.
        </Typography>
        <Typography
          variant="subtitle2"
          align="center"
          color="textSecondary"
          paragraph
          style={{
            fontStyle: "italic",
          }}
        >
          <sup>*</sup>Creation of template only. Personalized details can be
          incorporated with Vidyard's Custom Action editor.
        </Typography>
        <div className={classes.heroButtons}>
          <Grid container spacing={2} justify="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                href="mailto:services@vidyard.com"
                target="_blank"
                style={{
                  padding: "9px 20px",
                  borderRadius: "3px",
                  width: "192px",
                }}
              >
                Get Started <MailOutlineIcon style={{ marginLeft: 3}}/>
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                href="mailto:sales@vidyard.com"
                target="_blank"
                style={{ padding: "9px 20px", borderRadius: "3px" }}
              >
                Help Me Choose <MailOutlineIcon style={{ marginLeft: 3}}/>
              </Button>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}

export default Hero;
